"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = __importDefault(require("./wallets/Metamask/index"));
const nearwallet_1 = __importDefault(require("./wallets/NearWallets/nearwallet"));
const mynearwallet_1 = __importDefault(require("./wallets/NearWallets/mynearwallet"));
class Fabrica {
    static getWalletClass(name) {
        switch (name) {
            case 'METAMASK':
                return index_1.default;
            case 'NEARWALLET':
                return nearwallet_1.default;
            case 'MYNEARWALLET':
                return mynearwallet_1.default;
        }
        return undefined;
    }
    static createWallet(name, protocol) {
        if (!this.supportedProtocols[protocol]) {
            throw Error(`Protocol ${protocol} is not supported`);
        }
        const walletClass = this.getWalletClass(name);
        if (!walletClass) {
            throw Error(`Wallet ${name} is not supported`);
        }
        return new walletClass();
    }
}
Fabrica.supportedProtocols = {
    ETHEREUM: {
        wallets: ['METAMASK'],
    },
    NEAR: {
        wallets: ['NEARWALLET', 'MYNEARWALLET'],
    }
};
exports.default = Fabrica;
